// extracted by mini-css-extract-plugin
module.exports = {"delta":"deltanew_delta__eYvsL"};